<template>
    <div class="card card-with-shadow border-0 h-100 employee-preview-card">
        <div class="card-body position-relative d-flex flex-column justify-content-between">
            <div v-if="showAction" class="dropdown options-dropdown position-absolute">
                <button type="button"
                        class="btn-option btn d-flex align-items-center justify-content-center"
                        data-toggle="dropdown">
                    <app-icon name="more-horizontal"/>
                </button>
                <div class="dropdown-menu dropdown-menu-right py-2 mt-1">
                    <a class="dropdown-item px-4 py-2"
                       href="#"
                       v-for="(action,index) in actions"
                       :key="index"
                       v-if="checkIfVisible(action, employee)"
                       @click.prevent="callAction(action)">
                        {{ action.title }}
                    </a>
                </div>
            </div>
            <div class="text-center">
                <app-avatar :title="employee.full_name"
                            :status="employee.status.class"
                            avatar-class="avatars-w-50 mr-3 mb-2 d-inline-block"
                            :img="getImageUrl(employee)"/>

                <p class="mb-2">{{ $optional(employee, 'profile', 'employee_id') }} {{ employee.full_name ? employee.full_name : employee.email }}</p>
               
                <div class="text-muted">
                    <div class="d-flex justify-content-center">
                        <p class="mb-1" data-toggle="tooltip" data-placement="top" :title="$t('department')">
                            {{ $optional(employee, 'department', 'name') }}
                        </p>
                    </div>

                    <div class="d-flex justify-content-center">
                        <p class="mb-1 font-size-80 text-muted" data-toggle="tooltip" data-placement="top" :title="$t('designation')">
                            {{ $optional(employee, 'designation', 'name') }}
                        </p>
                    </div>
                   
                    <p class="mb-0" data-toggle="tooltip" data-placement="top" :title="$t('working_shift')">
                        {{ $optional(employee, 'working_shift', 'name') }}
                    </p>
                </div>

                <div v-if="employee.employment_status || employee.terminate_date" class="mt-2">
                    <app-employee-status
                        :row-data="employee"
                        :alignment-class="'justify-content-center'"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CoreLibrary from "../../../../../core/helpers/CoreLibrary";
import {EMPLOYEES_PROFILE, EMPLOYEES} from "../../../../Config/ApiUrl";
import {urlGenerator, axiosPatch} from "../../../../../common/Helper/AxiosHelper";

export default {
    name: "EmployeePreviewCard",
    extends: CoreLibrary,
    props: {
        employee: {
            type: Object,
            required: true
        },
        actions: {
            type: Array,
            require: true
        },
        showAction: {
            type: Boolean,
            default: true
        },
        id: {
            type: String,
            require: true
        }
    },
    methods: {
        callAction(action) {
            this.$emit('action-' + this.id, this.employee, action, true)
        },
        checkIfVisible(action, employee) {
            if (this.isFunction(action.modifier)) {
                return action.modifier(employee);
            }
            return true;
        },
        getImageUrl(employee) {
            if (employee.profile_picture) {
                return urlGenerator(employee.profile_picture.full_url);
            }
        },
        toggleRequireProfileUpdate(value) {
            axiosPatch(`${EMPLOYEES}/${this.employee.id}/toggle-require-profile-update`, {
                require_profile_update: value ? 1 : 0
            }).then(({data}) => {
                this.$toastr.s('', data.message);
                this.$hub.$emit('reload-employee-table');
            }).catch(({response}) => {
                this.$toastr.e('', response?.data?.message || 'Error');
            });
        }
    },
    computed: {
        profileUrl() {
            return urlGenerator(`${EMPLOYEES_PROFILE}/${this.employee.id}/profile`)
        }
    }
}
</script>

<style scoped>
::v-deep(.avatars-w-50 .status) {
    bottom: 0;
    top: 39px;
}
</style>